import { call, put, select, takeEvery, takeLatest } from "redux-saga/effects";
import axios from "../../../services/axios";
import subjectsServices from "../services/subjectsServices";
import contentService from "../services/contentService";
import { userServiceV2 } from "../../login/services/userServiceV2";
import relevantExamsService from "../services/relevantExamsService";
import { QuestionBenchmarkItem } from "../types/Benchmarks";
import { UPDATE_QUESTION_BENCHMARKS } from "../actions/actionType";
import { validateQuestionBenchmarks } from "../../../utils";
import { questionActions } from '../reducers/questionCreateReducer'

// worker Saga: will be fired on USER_FETCH_REQUESTED actions
function* fetchSubjects(action: any) {
  try {
    const res = yield call(subjectsServices.fetchSubjects, action.payload);
    yield put({ type: "FETCH_SUBJECTS_SUCCESS", payload: res });
  } catch (e) {
    yield put({ type: "FETCH_SUBJECTS_FAILED", message: e.message });
  }
}

function* getRandomQuestions(action: any) {
  try {
    const res = yield call(subjectsServices.getRandomQuestions, action.payload);
    yield put({ type: "GET_AUTO_GENERATE_SUCCESS", payload: res });
  } catch (e) {
    yield put({ type: "GET_AUTO_GENERATE_FAILURE", message: e.message });
  }
}
function* getRandomQuestionsCount(action: any) {
  try {
    const res = yield call(subjectsServices.getRandomQuestionsCount, action.payload);
    yield put({ type: "GET_COUNT_AUTO_GENERATE_SUCCESS", payload: res });
  } catch (e) {
    yield put({ type: "GET_COUNT_AUTO_GENERATE_FAILURE", message: e.message });
  }
}

// worker Saga: will be fired on USER_FETCH_REQUESTED actions
function* updateSubject(action: any) {
  try {
    const res = yield call(subjectsServices.updateSubject, action.payload);
    yield put({ type: "UPDATE_SUBJECT_SUCCESS", payload: res });
  } catch (e) {
    yield put({ type: "UPDATE_SUBJECT_FAILED", message: e.message });
  }
}

function* fetchEditLockInfo(action: any) {
  try {
    const { params, queryStrings } = action.data;
    const res = yield call(
      contentService.getEditLockInfo,
      params,
      queryStrings
    );
    yield put({ type: "FETCH_EDIT_LOCK_INFO_SUCCESS", data: res });
  } catch (e) {
    yield put({ type: "FETCH_EDIT_LOCK_INFO_FAILED", message: e.message });
  }
}

function* assignTest(action: any) {
  try {
    const { params } = action.data;
    const assignTestResponse = yield call(contentService.assignTest, params);
    const teacherTokenResponse = yield call(userServiceV2.getTeacherToken);
    yield put({
      type: "ASSIGN_TEST_SUCCESS",
      data: {
        assignTestResponse,
        teacherTokenResponse,
      },
    });
  } catch (e) {
    yield put({ type: "ASSIGN_TEST_FAILED", message: e.message });
  }
}

function* updateQuestionBenchmarksSaga(action: any) {
  try {
     const { questionId } = action.data
    const allQuestionBenchmarks = yield select(
      (state: any) => state.questionCreate.questionBenchmarks
    );
      console.log(allQuestionBenchmarks);
    const benchmarks: QuestionBenchmarkItem[] = allQuestionBenchmarks[questionId] ? allQuestionBenchmarks[questionId].benchmarks : [];
    const { hasErrors, errors } = validateQuestionBenchmarks(benchmarks);
    if(hasErrors) {
      yield put(questionActions.setQuestionBenchmarkErrors({ questionId, data: errors }));
    }
    const errorFreeBenchmarks = benchmarks.filter((_, i) => errors[i] && !errors[i].goalLevel && !errors[i].course);

    const filteredBenchmarks = errorFreeBenchmarks
      .filter(
        (benchmark: QuestionBenchmarkItem) =>
          !!benchmark.course.id && !!benchmark.goalLevel.id
      )
    
    const updatesCombinedBenchmarks = filteredBenchmarks.reduce((acc: QuestionBenchmarkItem[], benchmark: QuestionBenchmarkItem) => {
      const existingBenchmarkIndex = acc.findIndex(({ course: { name } }) => name === benchmark.course.name);
      // If benchmark already exists then merge with previous benchmark
      if(existingBenchmarkIndex > -1 && !benchmark.isDeleted) {
        acc[existingBenchmarkIndex] = benchmark;
      } else if (existingBenchmarkIndex === -1) {
        acc.push(benchmark);
      }
      return acc;
    }, []);

    const benchmarksFinalData = updatesCombinedBenchmarks.map((benchmark: QuestionBenchmarkItem) => ({
      isDeleted: benchmark.isDeleted,
      goalLevelId: benchmark.goalLevel.id,
      courseTypeId: benchmark.course.id,
    }));

    const data = {
      questionId,
      benchmarks: benchmarksFinalData
    };
    if (benchmarksFinalData.length > 0) {
      yield put(questionActions.setFinalQuestionBenchmarksPayload(data));
      yield call(contentService.updateBenchmarks, data);
    }
  } catch (error) {
    console.log(error);
  }
}

function* fetchBenchmark(action: any) {
   try {
      const {params} = action.data
      const res = yield call(contentService.fetchBenchMarkInfo, params);
      console.log(res);
      yield put({type: "FETCH_BENCHMARK_SUCCESS", data: res});
  } catch (e) {
     console.log('error', e)
   }
}

function* updateBenchmark(action: any) {
   try {
      const {payload} = action.data
      const res = yield call(contentService.updateBenchMarkInfo, payload);
         yield put({type: "UPDATE_BENCHMARK_SUCCESS", data: res});
  } catch (e) {
      console.log('error', e)
   }
}

function* fetchGoalLevels(action: any) {
   try {
      const {params} = action.data
      const res = yield call(contentService.fetchGoalLevels, params);
      yield put({type: "FETCH_GOAL_LEVELS_SUCCESS", data: res});
  } catch (e) {
   console.log('error', e)
   }
}

function* getRelevantExamsSaga(action: any) {
  try {
    const res = yield call(relevantExamsService.getRelevantExams);
    console.log(res);
  } catch (error) {
    console.log('Error: ', error)
  }
}
function* getContentSuggestions(action: any) {
  try {
    console.log("Step 2",{action});
    const res = yield call(contentService.getContentSuggestions, action.data);
    console.log("step 2.1",{res});
    if(res.statusCode===200)
       yield put({ type: "SET_CONTENT_SUGGESTIONS_SUCCESS", data: res.responseObject});
    else
      yield put({ type: "SET_CONTENT_SUGGESTIONS_FAILURE", message: res.responseMessage });   
  } catch (e) {
    yield put({ type: "SET_CONTENT_SUGGESTIONS_FAILURE", message: e.message });
  }
}
/*
  Alternatively you may use takeLatest.

  Does not allow concurrent fetches of user. If "USER_FETCH_REQUESTED" gets
  dispatched while a fetch is already pending, that pending fetch is cancelled
  and only the latest one will be run.
*/
function* myLibrarySaga() {
  yield takeLatest("FETCH_SUBJECTS", fetchSubjects);
  yield takeLatest("UPDATE_SUBJECT", updateSubject);
  yield takeLatest("FETCH_EDIT_LOCK_INFO", fetchEditLockInfo);
  yield takeLatest("ASSIGN_TEST", assignTest);
  yield takeEvery(UPDATE_QUESTION_BENCHMARKS, updateQuestionBenchmarksSaga);
  yield takeLatest("FETCH_BENCHMARK", fetchBenchmark);
  yield takeLatest("UPDATE_BENCHMARK", updateBenchmark);
  yield takeLatest("FETCH_GOAL_LEVELS", fetchGoalLevels);
  yield takeLatest("GET_RELEVANT_EXAMS", getRelevantExamsSaga);
  yield takeLatest("GET_AUTO_GENERATE", getRandomQuestions);
  yield takeLatest("GET_COUNT_AUTO_GENERATE", getRandomQuestionsCount); 
  yield takeLatest("SET_CONTENT_SUGGESTIONS", getContentSuggestions); 
}

// const syllabusSaga = {
//    fetchSubjects,
//    updateSubject
// }

export default myLibrarySaga;
